import Swagger from 'swagger-client';
import { handleError, error, receive, request } from '../../lib/Utils';
import fetch from 'isomorphic-fetch';
//import TruckingReactAPI from '../../lib/TruckingReactAPI';

//let api = new TruckingReactAPI({ domain: '/api' });
import saveAs from 'file-saver';
import FileSaver from 'file-saver';
import { callApi } from '../../lib/SwaggerApi';


export const JOB_REQUEST = {
  REQUEST: "JOB_REQUEST_REQUEST",
  SUCCESS: "JOB_REQUEST_SUCCESS",
  FAILURE: "JOB_REQUEST_FAILURE"
};

export const JOB_REQUEST_PDF = {
  REQUEST: "JOB_REQUEST_PDF_REQUEST",
  SUCCESS: "JOB_REQUEST_PDF_SUCCESS",
  FAILURE: "JOB_REQUEST_PDF_FAILURE"
};

export function jobRequestV1(parameters, callback = () => true) {

  var formData = new FormData();

  if (parameters.files) {
    parameters.files.forEach(file => {
      formData.append("files", file);
    });
  }

  Object.entries(parameters).forEach(keyVal => {
    if (keyVal.key != "files") {
      formData.append(...keyVal);
    }
  });

  return (dispatch) => {
    dispatch(request(JOB_REQUEST));

    return fetch('/api/jobs-v1', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    }).then((payload) => {
      // console.log(payload);
      if (payload.ok) {
        payload.json().then(json =>{
          dispatch(receive(JOB_REQUEST, json));
          callback(null, json);
        }).catch(err =>{
          dispatch(error(JOB_REQUEST, err));
          callback(err)
        });
        
      }
      else {
        handleError(dispatch, payload, JOB_REQUEST, callback);
      }
    })
      .catch(function (err) {
        dispatch(error(JOB_REQUEST, {
          message: err.message
        }));
        callback(err);
      });
  };


}


export function jobRequestPdf(parameters, callback = () => true) {
  var formData = new FormData();
  return (dispatch) => {
    dispatch(request(JOB_REQUEST_PDF));

    return fetch('/api/jobs-pdf', {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(parameters),
      credentials: 'same-origin'
    }).then((payload) => {      
      if (payload.ok) {        
        payload.blob().then(blob => {
          dispatch(receive(JOB_REQUEST_PDF, blob));
          callback(null, blob);
          //FileSaver.saveAs(blob, "quote.pdf");
        }).catch(err =>{
          dispatch(error(JOB_REQUEST_PDF, err));
          callback(err)
        });
        /*
        payload.json().then(json =>{
          dispatch(receive(JOB_REQUEST, json));
          callback(null, json);
        }).catch(err =>{
          dispatch(error(JOB_REQUEST, err));
          callback(err)
        });
        */
        
      }
      else {
        handleError(dispatch, payload, JOB_REQUEST_PDF, callback);
      }
    })
      .catch(function (err) {
        dispatch(error(JOB_REQUEST_PDF, {
          message: err.message
        }));
        callback(err);
      });
  };

}


// WEBPACK FOOTER //
// ./src/containers/Jobs/JobsActions.js